import { SwapPill } from "./SwapPill"
import { formatDateNumeric, getSwapPillInfo, formatDay } from "../utils"
import { IShiftSwapRequest } from "../interface/shiftData"
import { ChevronRightIcon } from "@heroicons/react/24/outline"

type ShiftSwapCardProps = {
  swap: IShiftSwapRequest
  perspective: "sender" | "receiver"
  onViewRequest: () => void
}

export const ShiftSwapCard = ({
  swap,
  perspective,
  onViewRequest,
}: ShiftSwapCardProps) => {
  const pill = getSwapPillInfo(swap, perspective)
  const name =
    perspective === "sender"
      ? swap.targetEmployee.fullName
      : swap.requester.fullName
  const sourceDate = formatDay(swap.sourceSwapDate ?? "")
  const targetDate = formatDay(swap.targetSwapDate ?? "")
  const isSwap = swap.targetShiftAssignmentId !== null

  return (
    <div className="w-full px-3.5 mx-0.5 hover:transition-all">
      <p className="flex items-center justify-between gap-3">
        <span className="text-sm">
          {perspective === "sender" ? (
            <>
              <strong>You</strong> <span className="text-[#62748E]">to</span>{" "}
              <strong>{name}</strong>
            </>
          ) : (
            <>
              <strong>{name}</strong> <span className="text-[#62748E]">to</span>{" "}
              <strong>You</strong>
            </>
          )}
        </span>
        <span className="text-[#62748E]">
          {formatDateNumeric(swap.createdDate)}
        </span>
      </p>
      <p className="text-sm text-[#62748E]">
        {perspective === "sender"
          ? `You requested to give ${name} your ${sourceDate} shift.`
          : `${name} requested to give you their ${sourceDate} shift.`}
      </p>
      {isSwap && (
        <p className="text-sm text-[#62748E]">
          {perspective === "sender"
            ? `You requested to take ${name}'s ${targetDate} shift.`
            : `${name} requested to take your ${targetDate} shift.`}
        </p>
      )}
      {pill && <SwapPill {...pill} />}
      <button
        className="text-[#004AF5] font-bold cursor-pointer flex items-center gap-2"
        onClick={onViewRequest}
      >
        View request <ChevronRightIcon className="w-3 h-3" />
      </button>
    </div>
  )
}
